import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SchemaMarkup from '../../components/base/SchemaMarkup';

const applicationsSchema = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Laser Machine Applications - Redsail Laser Malta",
    "description": "Discover the wide range of materials and applications for Redsail laser machines: leather, metal, glass, wood, acrylic, fabric, paper, and rubber processing.",
    "url": "https://redsaillaser-malta.com/applications"
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Laser Machine Applications",
    "description": "Materials and industries served by Redsail laser cutting and engraving machines",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Leather Crafting", "description": "Precision cutting and engraving for bags, wallets, belts, and leather accessories" },
      { "@type": "ListItem", "position": 2, "name": "Metal Engraving", "description": "Detailed marking on coated metals, anodized aluminum, and stainless steel" },
      { "@type": "ListItem", "position": 3, "name": "Glass Etching", "description": "Frosted effects and detailed designs on glass, crystal, and mirror surfaces" },
      { "@type": "ListItem", "position": 4, "name": "Wood Working", "description": "Intricate cutting and engraving on plywood, MDF, solid wood, and bamboo" },
      { "@type": "ListItem", "position": 5, "name": "Acrylic Design", "description": "Clean cuts and precise engravings for signage, displays, and decorative pieces" },
      { "@type": "ListItem", "position": 6, "name": "Fabric & Textile", "description": "Precise cutting for fashion, upholstery, and technical fabrics" },
      { "@type": "ListItem", "position": 7, "name": "Paper & Cardboard", "description": "Delicate cutting for invitations, packaging, and paper art" },
      { "@type": "ListItem", "position": 8, "name": "Rubber & Foam", "description": "Accurate cutting of rubber stamps, gaskets, and foam inserts" }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://redsaillaser-malta.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Applications",
        "item": "https://redsaillaser-malta.com/applications"
      }
    ]
  }
];

const applications = [
  {
    id: 1,
    title: 'Leather Crafting',
    description: 'Precision cutting and engraving for bags, wallets, belts, and leather accessories with intricate detail.',
    image: 'https://readdy.ai/api/search-image?query=Close-up%20view%20of%20laser%20technology%20cutting%20through%20rich%20brown%20leather%20material%20for%20premium%20handbag%20production%20in%20contemporary%20manufacturing%20workspace%20with%20soft%20natural%20lighting%20and%20cream%20colored%20walls%20highlighting%20craftsmanship%20quality&width=600&height=450&seq=leather-app-opt-001&orientation=landscape',
    features: ['Custom patterns', 'Precise cuts', 'Detailed engraving', 'Multiple leather types']
  },
  {
    id: 2,
    title: 'Metal Engraving',
    description: 'Detailed marking and engraving on coated metals, anodized aluminum, and stainless steel surfaces.',
    image: 'https://readdy.ai/api/search-image?query=Precision%20laser%20marking%20machine%20engraving%20fine%20detailed%20patterns%20onto%20silver%20anodized%20aluminum%20metal%20plate%20in%20high-tech%20industrial%20setting%20with%20bright%20white%20lighting%20and%20clean%20modern%20environment&width=600&height=450&seq=metal-app-opt-002&orientation=landscape',
    features: ['Permanent marking', 'High contrast', 'Serial numbers', 'Logo engraving']
  },
  {
    id: 3,
    title: 'Glass Etching',
    description: 'Beautiful frosted effects and detailed designs on glass, crystal, and mirror surfaces.',
    image: 'https://readdy.ai/api/search-image?query=Laser%20engraving%20creating%20sophisticated%20frosted%20artistic%20design%20on%20transparent%20crystal%20glass%20surface%20for%20luxury%20decorative%20items%20in%20elegant%20workshop%20with%20soft%20lighting%20and%20light%20background&width=600&height=450&seq=glass-app-opt-003&orientation=landscape',
    features: ['Frosted finish', 'Deep etching', 'Photo reproduction', 'Awards & gifts']
  },
  {
    id: 4,
    title: 'Wood Working',
    description: 'Intricate cutting and engraving on plywood, MDF, solid wood, and bamboo materials.',
    image: 'https://readdy.ai/api/search-image?query=Advanced%20laser%20cutting%20equipment%20creating%20complex%20decorative%20patterns%20in%20natural%20wood%20plywood%20material%20for%20furniture%20and%20craft%20projects%20in%20bright%20modern%20carpentry%20workshop%20with%20white%20walls&width=600&height=450&seq=wood-app-opt-004&orientation=landscape',
    features: ['Complex patterns', 'Deep engraving', 'Furniture parts', 'Decorative items']
  },
  {
    id: 5,
    title: 'Acrylic Design',
    description: 'Clean cuts and precise engravings on acrylic sheets for signage, displays, and decorative pieces.',
    image: 'https://readdy.ai/api/search-image?query=High%20precision%20laser%20system%20cutting%20clear%20transparent%20acrylic%20sheet%20material%20for%20professional%20signage%20and%20display%20production%20in%20contemporary%20workshop%20with%20excellent%20lighting%20and%20pale%20neutral%20surroundings&width=600&height=450&seq=acrylic-app-opt-005&orientation=landscape',
    features: ['Edge polishing', 'Clear cuts', '3D effects', 'Signage production']
  },
  {
    id: 6,
    title: 'Fabric & Textile',
    description: 'Precise cutting for fashion, upholstery, industrial textiles, and technical fabrics without fraying.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20textile%20laser%20cutting%20technology%20precisely%20cutting%20vibrant%20colored%20fabric%20material%20for%20fashion%20design%20applications%20in%20clean%20bright%20manufacturing%20facility%20with%20white%20background%20showing%20accurate%20cutting&width=600&height=450&seq=fabric-app-opt-006&orientation=landscape',
    features: ['No fraying', 'Complex shapes', 'Multiple layers', 'Fast production']
  },
  {
    id: 7,
    title: 'Paper & Cardboard',
    description: 'Delicate cutting and scoring for invitations, packaging, paper art, and cardboard prototypes.',
    image: 'https://readdy.ai/api/search-image?query=Precision%20laser%20cutting%20machine%20creating%20intricate%20decorative%20patterns%20in%20premium%20white%20cardstock%20paper%20for%20wedding%20invitation%20and%20greeting%20card%20production%20in%20bright%20clean%20studio%20with%20soft%20lighting%20and%20minimal%20background&width=600&height=450&seq=paper-app-opt-007&orientation=landscape',
    features: ['Intricate designs', 'Clean edges', 'Scoring lines', 'Prototype making']
  },
  {
    id: 8,
    title: 'Rubber & Foam',
    description: 'Accurate cutting of rubber stamps, gaskets, foam inserts, and cushioning materials.',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20laser%20equipment%20cutting%20through%20black%20rubber%20material%20for%20gasket%20and%20seal%20manufacturing%20in%20modern%20production%20facility%20with%20bright%20overhead%20lighting%20and%20clean%20white%20workspace%20environment&width=600&height=450&seq=rubber-app-opt-008&orientation=landscape',
    features: ['Stamp making', 'Gasket cutting', 'Foam inserts', 'Custom shapes']
  }
];

const industries = [
  {
    name: 'Advertising & Signage',
    description: 'Create eye-catching signs, displays, and promotional materials.',
    icon: 'ri-megaphone-line',
  },
  {
    name: 'Fashion & Apparel',
    description: 'Design and manufacture clothing, accessories, and textile products.',
    icon: 'ri-t-shirt-line',
  },
  {
    name: 'Furniture & Interior',
    description: 'Produce custom furniture parts, decorations, and interior elements.',
    icon: 'ri-home-4-line',
  },
  {
    name: 'Packaging Industry',
    description: 'Design and prototype packaging solutions and custom boxes.',
    icon: 'ri-archive-line',
  },
  {
    name: 'Arts & Crafts',
    description: 'Create unique handmade items, gifts, and artistic pieces.',
    icon: 'ri-palette-line',
  },
  {
    name: 'Education & Research',
    description: 'Support learning, prototyping, and research projects.',
    icon: 'ri-graduation-cap-line',
  },
];

const ApplicationsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={applicationsSchema} />
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <span className="text-emerald-500 font-semibold text-sm tracking-wider uppercase">
            Applications
          </span>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mt-3 mb-6">
            Endless Possibilities
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover the wide range of materials and applications our laser machines can handle. 
            From industrial production to creative crafts, we've got you covered.
          </p>
        </div>
      </section>

      {/* Applications Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-8">
            {applications.map((app, index) => (
              <div
                key={index}
                className="group bg-gray-50 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-500"
              >
                <div className="relative h-64 overflow-hidden bg-gray-200">
                  <img
                    src={app.image}
                    alt={app.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-6 left-6 right-6">
                    <h3 className="text-2xl font-bold text-white">{app.title}</h3>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-gray-600 mb-4">{app.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {app.features.map((feature, i) => (
                      <span
                        key={i}
                        className="px-3 py-1 bg-white text-gray-700 text-sm rounded-full border border-gray-200"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Industries We Serve</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Our laser machines are trusted by professionals across various industries worldwide.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {industries.map((industry, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 hover:shadow-lg transition-all"
              >
                <div className="w-14 h-14 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                  <i className={`${industry.icon} text-2xl text-emerald-500`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{industry.name}</h3>
                <p className="text-gray-600">{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-emerald-500">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Explore our range of laser machines and find the perfect solution for your application.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/products"
              className="px-8 py-4 bg-white text-emerald-600 font-semibold rounded-full hover:bg-gray-100 transition-all whitespace-nowrap"
            >
              View Products
            </Link>
            <Link
              to="/contact"
              className="px-8 py-4 bg-emerald-600 text-white font-semibold rounded-full hover:bg-emerald-700 transition-all whitespace-nowrap"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ApplicationsPage;
